import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";

const Input = ({
  label,
  value,
  varient,
  name,
  id,
  onChange,
  size,
  type,
  readOnly,
  required,
  minRows,
  multiline = false,
  disabled = false,
}) => {
  const [inputValue, setInputValue] = useState("");
  const inputChange = (e) => {
    setInputValue(e.target.value);
    onChange(e.target.value);
  };

  // useEffect(() => {
  //     setInputValue(value)
  // }, [value])

  useEffect(() => {
    setInputValue(value);
  });

  return (
    <FormControl fullWidth>
      <TextField
        // className='input-all'
        multiline={multiline}
        label={label !== undefined ? label : ""}
        type={type !== undefined ? type : "text"}
        variant={varient !== undefined ? varient : "standard"}
        value={inputValue !== null ? inputValue : ""}
        name={name !== undefined ? name : ""}
        id={id !== undefined ? id : ""}
        onChange={(e) => inputChange(e)}
        minRows={minRows ?? 1}
        size={size !== undefined ? size : ""}
        inputProps={{ readOnly: readOnly !== undefined ? readOnly : false }}
        required={required !== undefined ? required : false}
        disabled={disabled}
      />
    </FormControl>
  );
};

export default Input;
